import React from 'react';
import PropTypes from 'prop-types';
import {Typography} from '@customink/pigment-react';

import './Welcome_Lg.scss';
import {useAuth} from '~/auth/AuthContext';

const RetrieveDesignsButton = props => {
  return (
    <div className="ndx-Welcome_Lg-button" onClick={props.onRetrieveDesigns}>
      <div className="ndx-Welcome_Lg-buttonImage welcomeRetrieveDesignImage" />
      <Typography variant="uiTextSmall" className="ndx-Welcome_Lg-buttonText">
        Retrieve a
        <br />
        Saved Design
      </Typography>
    </div>
  );
};

RetrieveDesignsButton.displayName = 'RetrieveDesignsButton';

const ReviewCartButton = props => {
  return (
    <div className="ndx-Welcome_Lg-button" onClick={props.onCheckout}>
      <div className="ndx-Welcome_Lg-buttonImage welcomeCheckoutImage" />
      <Typography variant="uiTextSmall" className="ndx-Welcome_Lg-buttonText">
        Review Cart &
        <br />
        Checkout
      </Typography>
    </div>
  );
};

ReviewCartButton.displayName = 'ReviewCartButton';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const StartButtons = props => {
  const auth = useAuth();

  const {cartItemCount, customDimension, isMultiItemEligible} = props;

  const onAddText = event => {
    props.onAddText(event, customDimension);
    props.onTextStart({
      source: 'wb'
    });
  };
  const onUpload = event => {
    props.onUpload(event, customDimension);
  };

  const onAddArt = event => {
    props.onAddArt(event, customDimension);
  };

  const onProduct = event => {
    props.onProduct(event, customDimension);
  };

  const onCheckout = event => {
    props.onCheckout(event, customDimension);
  };

  const onRetrieveDesigns = event => {
    props.onRetrieveDesigns(event, customDimension);
  };

  return (
    <div className="ndx-Welcome_Lg-buttons">
      <div className="ndx-Flex-Row">
        <div className="ndx-Welcome_Lg-button" onClick={onUpload}>
          <div className="ndx-Welcome_Lg-buttonImage welcomeUploadCTAImage" />
          <Typography
            variant="uiTextSmall"
            data-testid="StartButton-upload"
            className="ndx-Welcome_Lg-buttonText">
            Upload
          </Typography>
        </div>
        <div
          className="ndx-Welcome_Lg-button"
          data-testid="onAddText"
          onClick={onAddText}>
          <div className="ndx-Welcome_Lg-buttonImage welcomeTextCTAImage" />
          <Typography
            variant="uiTextSmall"
            className="ndx-Welcome_Lg-buttonText">
            Add Text
          </Typography>
        </div>
      </div>
      <div className="ndx-Flex-Row">
        <div className="ndx-Welcome_Lg-button" onClick={onAddArt}>
          <div className="ndx-Welcome_Lg-buttonImage welcomeArtCTAImage" />
          <Typography
            variant="uiTextSmall"
            className="ndx-Welcome_Lg-buttonText">
            {'Add Art'}
          </Typography>
        </div>
        <div className="ndx-Welcome_Lg-button" onClick={onProduct}>
          <div className="ndx-Welcome_Lg-buttonImage welcomeProductCTAImage" />
          <Typography
            variant="uiTextSmall"
            className="ndx-Welcome_Lg-buttonText">
            Change
            <br />
            Products
          </Typography>
        </div>
      </div>
      {isMultiItemEligible && (
        <div className="ndx-Flex-Row">
          {props.isRetrieveDesignsActive ? (
            <>
              {auth.user && (
                <RetrieveDesignsButton onRetrieveDesigns={onRetrieveDesigns} />
              )}
            </>
          ) : (
            <>
              {cartItemCount > 0 && (
                <RetrieveDesignsButton onRetrieveDesigns={onRetrieveDesigns} />
              )}
            </>
          )}
          {cartItemCount > 0 && <ReviewCartButton onCheckout={onCheckout} />}
        </div>
      )}
    </div>
  );
};

StartButtons.displayName = 'StartButtons';

const propTypes = {
  cartItemCount: PropTypes.number,
  customDimension: PropTypes.string,
  isMultiItemEligible: PropTypes.bool,
  isWaysToGetStartedTest: PropTypes.bool,
  onAddArt: PropTypes.func,
  onAddText: PropTypes.func,
  onChangeProductColor: PropTypes.func,
  onCheckout: PropTypes.func,
  onProduct: PropTypes.func,
  onRetrieveDesigns: PropTypes.func,
  onTextStart: PropTypes.func,
  onUpload: PropTypes.func
};

StartButtons.propTypes = propTypes;

export default StartButtons;
